import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';

interface UtilisationWidgetProps {
  occupancy: number,
  limit: number,
  live?: boolean,
}

const UtilisationWidget = ({ occupancy, limit, live }: UtilisationWidgetProps) => {
  let percentage: number | null = Math.floor(100 * (occupancy / limit));
  if (!Number.isFinite(percentage)) percentage = null;

  return <View style={[Style.row, styles.container]}>
    <View style={styles.section}>
      <Text style={styles.title}>{live ? 'Utilisation' : 'Average utilisation'}</Text>
      <Text style={styles.value}>{`${percentage ?? '- '}%`}</Text>
    </View>
    {/* <View style={styles.section}>
      <Text style={styles.title}>{'Busiest time'}</Text>
      <Text style={styles.value}>{'3pm - 4pm'}</Text>
    </View> */}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
    marginHorizontal: -8,
  },
  section: {
    flex: 1,
    marginTop: 4,
    marginHorizontal: 8,
  },
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 4,
  },
  value: {
    fontSize: 18,
    lineHeight: 14,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
  },
});

export default UtilisationWidget;
